import { useState, useEffect } from 'react';
import { pageAPI } from '../services/api';
import { StaticPage } from '../types';

export const useStaticPage = (slug: string) => {
  const [page, setPage] = useState<StaticPage | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    const fetchPage = async () => {
      try {
        const response = await pageAPI.getBySlug(slug);
        if (active) {
          setPage(response.data || null);
        }
      } catch (err) {
        console.warn(`Failed to load dynamic page for slug '${slug}', using static fallback.`, err);
      } finally {
        if (active) {
          setLoading(false);
        }
      }
    };
    fetchPage();
    return () => {
      active = false;
    };
  }, [slug]);

  return { page, loading };
};
export default useStaticPage;
